// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2mFeA","noInteraction":"EventWrapper_noInteraction__2BW1o"};